const EASING = 'cubic-bezier(0.79, 0.21, 0.65, 1.12)'
const EASING_OUT = 'cubic-bezier(0.26, 0.58, 0.83, 0.69)'
const EASING_IN = 'cubic-bezier(0.57, 0.02, 0.64, 0.96)'
const DURATION = 400
const DURATION_MS = `${DURATION}ms`

export default {
  EASING,
  EASING_OUT,
  EASING_IN,
  DURATION,
  DURATION_MS,
}
